export const getRoleTypeNameFromUser = (user) => {
  let returnString = '';
  if (user?.roles) {
    returnString = user.roles.map((role) => {
      return role.split('-')[0];
    });
  }
  return returnString;
};